import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing(0.5)};
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
  min-height: 0;

  overflow: auto;
`;

export const ScrollContainer = styled.div`
  height: 100%;
  overflow: auto;
  padding-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const InteractionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`;
